let filters = {
	emp_id: {name: 'emp_id', 'nickname': 'Employee', type: 'multi', options: {},selections: {}, size: 2},
	company: {name: 'company', 'nickname': 'Company', type: 'text', options: {},selections: {}, size: 2}
}

module.exports = filters